import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">
                USFans <span className="text-primary-600">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {t('footer_tagline')}
            </p>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-foreground-400">
              {t('footer_disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <a href="#categories" className="cursor-pointer">{t('footer_categories')}</a>
            </h4>
            <ul className="mt-4 space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer"
                  >
                    {t(`category_${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">{t('footer_resources')}</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">{t('footer_home')}</Link>
              </li>
              <li>
                <Link to="/article/what-is-a-usfans-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">{t('footer_guide')}</Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer"
                >
                  {t('footer_visit_main')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">
            © {new Date().getFullYear()} USFans Spreadsheet Hub. {t('footer_rights')}
          </p>
          <p className="text-xs text-foreground-400">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-primary-600 cursor-pointer"
            >
              kaspreadsheet.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}